<ion-header>
  <div class="modal-header">
    <div class="modal-title">
      <h3>Automation Logs</h3>
    </div>
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button
          fill="clear"
          shape="round"
          class="close-button"
          (click)="dismiss()"
        >
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </div>
  <div style="padding: 0 10px 10px 10px" *ngIf="run">
    <!-- Status Pill -->
    <ion-button
      fill="clear"
      [color]="run.status === 'failed' ? 'danger' : 'success'"
      class="btn-xs no-margin"
    >
      <ion-icon
        [name]="run.status === 'failed' ? 'close-circle' : 'checkmark-circle'"
        class="button-icon"
      ></ion-icon>
      {{ run.status === "failed" ? "Failed" : "Success" }}
    </ion-button>

    <!-- Automation Pill (clickable) -->
    <ion-button
      fill="clear"
      color="dark"
      (click)="viewAutomation()"
      class="btn-xs no-margin"
    >
      <ion-icon name="flash-outline" class="button-icon"></ion-icon>
      {{ run.automation?.name }}
    </ion-button>

    <!-- Conversation Pill (clickable) -->
    <ion-button
      *ngIf="conversationFriendlyId"
      fill="clear"
      color="dark"
      (click)="viewConversation()"
      class="btn-xs no-margin"
    >
      <ion-icon name="chatbubble-outline" class="button-icon"></ion-icon>
      Conversation #{{ conversationFriendlyId }}
    </ion-button>
  </div>
</ion-header>

<ion-content class="ion-padding">
  <div *ngIf="run">
    <!-- Input Section (if exists) -->
    <ion-label class="input-label" *ngIf="run.input">Input</ion-label>
    <ion-list *ngIf="run.input">
      <ion-item>
        <pre style="margin: 0; text-wrap: wrap; font-size: 0.8rem">{{
          run.input | json
        }}</pre>
      </ion-item>
    </ion-list>

    <!-- Logs Section with controls -->
    <div class="logs-header">
      <ion-label class="input-label margin-top">Execution Logs</ion-label>
      <div class="logs-controls">
        <div class="control-item btn-xs">
          <ion-checkbox
            [(ngModel)]="hideMetadata"
            (ionChange)="getLogs()"
          ></ion-checkbox>
          <ion-label>Hide metadata</ion-label>
        </div>
        <ion-button
          fill="clear"
          size="small"
          (click)="copyToClipboard()"
          [disabled]="!automationRunLogs?.length"
          class="btn-xs button-dark-border"
          color="dark"
        >
          <ion-icon name="copy-outline" slot="start"></ion-icon>
          Copy All
        </ion-button>
      </div>
    </div>

    <!-- Log Content -->
    <ion-list lines="none" *ngIf="!isLoading">
      <ion-item *ngFor="let log of automationRunLogs" class="log-item">
        <pre
          style="margin: 0; text-wrap: wrap"
          [class.success-log]="log.includes('✅')"
          [class.error-log]="log.includes('❌')"
          >{{ log }}</pre
        >
      </ion-item>

      <ion-item *ngIf="!automationRunLogs?.length">
        <ion-label>
          <div class="empty-state">
            <ion-icon
              name="document-text-outline"
              class="empty-icon"
            ></ion-icon>
            <p class="empty-text">No logs available for this automation run.</p>
            <p class="empty-subtext">Logs are only available for 30 days</p>
          </div>
        </ion-label>
      </ion-item>
    </ion-list>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-state">
      <ion-spinner name="crescent"></ion-spinner>
      <p>Loading logs...</p>
    </div>
  </div>
</ion-content>
